import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import TextareaAutosize from 'react-autosize-textarea'
import { AppInput, Label } from '../../components'
import { Engine } from 'yatte'

const renderSuggestions = (id, suggestionType, optionsExpr, scope) => {
  if (suggestionType && optionsExpr && (suggestionType !== 'none') && (optionsExpr !== '[]')) {
    const optEvaluator = Engine.compileExpr(optionsExpr)
    const optArray = scope.evaluate(optEvaluator)
    if (Array.isArray(optArray)) {
      const bareArray = optArray.__value || optArray
      const validOpts = bareArray.reduce((prev, curr) => {
        if (curr) {
          prev.push(curr.toString())
        }
        return prev
      }, [])
      if (validOpts.length > 0) {
        return (
          <datalist id={id + 'list'}>
            {validOpts.map((option, index) => <option key={option + index}>{option}</option>)}
          </datalist>
        )
      }
    }
  }
  return null
}

const Text = ({
  id, name, label, type, style, helpText, suggestion, _options, index, value, context,
  height, allowBreaks, pattern, onChange, activate, unlabeled,
}) => {
  if (unlabeled) {
    helpText = null
    label = null
  }
  const localChange = val => {
    if (val) {
      if (!allowBreaks) {
        val = val.replace(/\r?\n/g, '')
      }
      return val
    }
    return null
  }

  if (style === 'hidden') {
    return null
  }
  if (height === 1 || height === undefined) {
    return (
      <Fragment>
        <AppInput key={id} id={id} name={name} label={label} index={index}
                  helpText={helpText}
                  value={value} onChange={val => onChange(localChange(val), index)}
                  type={type} pattern={pattern || null} activate={activate}
                  list={suggestion !== 'none' ? id + 'list' : ''}/>
        {renderSuggestions(id, suggestion, _options, context.scope)}
      </Fragment>
    )
  }
  if (height > 1) {
    const inList = (typeof index === 'number' && index >= 0)
    return (
      <div key={id} className={inList ? 'input-group mb-1' : 'form-group'}>
        {inList
          ? (
            <div className="input-group-prepend">
              <span className="input-group-text">
                {(index + 1) + '.'}
              </span>
            </div>
          )
          : (
            <Label name={name} helpText={helpText} label={label} forId={id}/>
          )
        }
        <TextareaAutosize id={id} rows={height} value={value}
                          autoFocus={activate || null} pattern={pattern || null}
                          className="form-control rounded-2" style={{ resize: 'none' }}
                          onKeyUp={(event) => {
                            if (event.keyCode === 13 && allowBreaks) {
                              event.stopPropagation()
                              event.preventDefault()
                            }
                          }
                          }
                          onChange={e => onChange(localChange(e.target.value), index)}
        />
      </div>
    )
  }
  return null
}

Text.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  index: PropTypes.number,
  value: PropTypes.string,
  height: PropTypes.number,
  allowBreaks: PropTypes.bool,
  pattern: PropTypes.string,
  onChange: PropTypes.func,
}

export default memo(Text)
